import React from "react";

const features = [
  {
    icon: "fas fa-bolt",
    title: "Instant Recharges",
    description:
      "Recharge mobile, DTH, and utility services quickly and securely, with real-time confirmations.",
  },
  {
    icon: "fas fa-rupee",
    title: "Earn Upto 4% Commissions",
    description:
      "Get upto 4% instant commissions credited to wallet on every mobile and dth recharge.",
  },
  {
    icon: "fas fa-money-bill-wave",
    title: "Secure UPI Payments",
    description:
      "Make all your recharges seamlessly using UPI, ensuring quick, hassle-free, and secure transactions.",
  },
  {
    icon: "fas fa-shield-alt",
    title: "Secure Transactions",
    description:
      "Bank-grade encryption ensures all transactions and customer data remain protected.",
  },
  {
    icon: "fas fa-user",
    title: "User-Friendly Interface",
    description:
      "Navigate effortlessly through a simple and intuitive design, making transactions smooth and easy.",
  },
  {
    icon: "fas fa-question-circle",
    title: "24/7 Support",
    description:
      "Get access to round-the-clock customer support to help with any issues or queries.",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-5 bg-light">
      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="section-title">Recharge POS App Features</h2>
          <p className="lead">
            Everything you need — all in one, for everyone.
          </p>
        </div>

        <div className="row">
          {features.map((feature, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="feature-card card h-100">
                <div className="card-body text-center p-4">
                  <div className="icon-box bg-primary-light rounded-circle p-3 mb-4 mx-auto">
                    <i className={`${feature.icon} fa-2x text-primary`}></i>
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
